export const SET_GAME = "SET_GAME";
export const SET_GROUP = "SET_GROUP";
export const SET_GAME_TEXTS = "SET_GAME_TEXTS";
export const SET_QUIZ_CACHE = "SET_QUIZ_CACHE";
export const UPDATE_SCENARIO = "UPDATE_SCENARIO";
export const UPDATE_TIME = "UPDATE_TIME";
export const SUM_SCORES = "SUM_SCORES";
export const UPDATE_SCORE = "UPDATE_SCORES";

export function setGame(game) {
	return {
		type: SET_GAME,
		game,
	};
}
export function setGroup(group) {
	return {
		type: SET_GROUP,
		group,
	};
}
/** Guarda en caché los textos del juego para evitar parpadeo al cambiar de página. */
export function setGameTexts(gameId, keyValueMap) {
	return {
		type: SET_GAME_TEXTS,
		gameId,
		keyValueMap,
	};
}

/** Guarda en caché el quiz de un escenario para precargar la siguiente pantalla. */
export function setQuizCache(scenarioId, payload) {
	return {
		type: SET_QUIZ_CACHE,
		scenarioId,
		payload,
	};
}
export function updateScore(score, typeOfScore) {
	return {
		type: UPDATE_SCORE,
		score,
		typeOfScore,
	};
}
export function updateScenario(activeScenario) {
	return {
		type: UPDATE_SCENARIO,
		activeScenario,
	};
}
export function updateTime(time) {
	return {
		type: UPDATE_TIME,
		time,
	};
}
